import { Component, OnInit } from '@angular/core';
import {FormGroup} from '@angular/forms';
import {QuestionnaireService} from '../../../../services/questionnaire.service';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../store/app.states';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {MatOptionSelectionChange} from '@angular/material/core';
import {ErrorDialogComponent} from '../../../user-actions/error-dialog/error-dialog.component';
import {MMAS8Results, Q_MMAS_8} from '../../../../model/questionnaires/questionnaire-mmas8';
import {User} from '../../../../model/user/User';

@Component({
  selector: 'app-questionnaire-mmas8',
  templateUrl: './questionnaire-mmas8.component.html',
  styleUrls: ['./questionnaire-mmas8.component.css']
})
export class QuestionnaireMmas8Component implements OnInit {

  qForm: FormGroup;
  dataSource = Q_MMAS_8;
  notFocused = false;
  submitted = false;
  show = false;
  displayedColumns = ['position', 'question', 'value'];
  values: string[] = ['Si', 'No'];
  values2q: string[] = ['Mai/molto raramente', 'Raramente', 'A volte', 'Spesso', 'Sempre'];
  results = [];

  /// toolbar
  back = true;
  found = false;
  title = 'MMAS-8';
  destination = '/questionnaires';
  user: User = null;
  uuid = null;
  authorization: boolean;
  doctorID: string;
  patientSSN: string;
  finalScore = 0;

  constructor(private questionnaireService: QuestionnaireService,
              private store: Store<AppState>,
              private route: ActivatedRoute,
              public dialog: MatDialog,
              private router: Router) { }

  ngOnInit(): void {

    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.dataSource.length; ++i) {
      this.results.push(null);
    }

    this.user = JSON.parse(localStorage.getItem('user'));
    this.route.params.subscribe(params => {
      this.doctorID = params.doctorID;
      this.patientSSN = params.patientSSN;
      this.uuid = params.uuid;
      this.authorization = this.user.ssn.localeCompare(params.patientSSN) === 0;
      if (params.back.localeCompare('questionnaires') === 0) {
        this.destination = 'questionnaires';
      } else if (params.back.localeCompare('choose-questionnaire') === 0) {
        this.destination = 'choose-questionnaire';
      }
    });
  }

  selectResult($event: MatOptionSelectionChange, value: string, position: number) {
    if ($event.isUserInput) {
      if (position >= 1 && position <= 7 && position !== 5) {
        if (this.results[position - 1] !== null) {
          let dec = 0;
          this.values.forEach(answer => {
            if (answer === this.results[position - 1]) {
              this.finalScore -= dec;
              console.log('Final Score After:', this.finalScore);
            }
            dec++;
          });
        }
        let inc = 0;
        this.values.forEach(answer => {
          if (answer === value) {
            this.finalScore += inc;
          }
          inc++;
        });
      } else if (position === 5) {
        if (this.results[position - 1] !== null) {
          let dec = this.values.length - 1;
          this.values.forEach(answer => {
            if (answer === this.results[position - 1]) {
              this.finalScore -= dec;
              console.log('Final Score After:', this.finalScore);
            }
            dec--;
          });
        }
        let inc = this.values.length - 1;
        this.values.forEach(answer => {
          if (answer === value) {
            this.finalScore += inc;
          }
          inc--;
        });
      } else if (position === 8) {
          if (this.results[position - 1] !== null) {
            let dec = this.values2q.length - 1;
            console.log('Dec', dec);
            this.values2q.forEach(answer => {
              if (answer === this.results[position - 1]) {
                this.finalScore -= dec;
                console.log('Final Score After:', this.finalScore);
              }
              dec--;
            });
          }
          let inc = this.values2q.length - 1;
          console.log('Inc', inc);
          this.values2q.forEach(answer => {
            console.log('answer', answer);
            console.log('value', value);
            if (answer === value) {
              this.finalScore += inc;
            }
            inc--;
          });
      }
      console.log('Final Score Value set:', this.finalScore);
      this.results[position - 1] = value;
      console.log(this.results);
    }
  }

  onSubmit() {
    this.submitted = true;
    this.show = true;
    this.found = false;

    if (this.results.length !== this.dataSource.length) {
      this.show = false;
      this.submitted = false;
      this.found = true;
      const msg = 'Non hai finito di completare il questionario!';
      this.openErrorDialog(msg);
    } else {
      for (const r of this.results) {
        if (r === null) {
          this.show = false;
          this.submitted = false;
          this.found = true;
          const msg = 'Non hai finito di completare il questionario!';
          this.openErrorDialog(msg);
          break;
        }
      }

      if (!this.found) {
        console.log(this.finalScore);
        console.log(this.patientSSN);
        const resultToSend = new MMAS8Results(this.doctorID, this.patientSSN, this.results, this.finalScore);
        this.questionnaireService.sendForm(resultToSend, 'mmas8', this.uuid);
      }
    }
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  goHome() {
    if (this.user === null) {
      this.router.navigateByUrl('/startup');
    } else {
      this.router.navigateByUrl('/landing');
    }
  }

}
